export default __webpack_public_path__ + "static/media/sensotrend_signin_login.27975ae3.png";